import { debounce } from "./helpers"

export default class NotificationBar {

  constructor() {
    this.notificationBar = document.querySelector('.notification-bar')
    this.pageBody = document.body
    this.pageHeader = document.querySelector('.pageheader')

    if (this.notificationBar) {
      this.checkSessionStorage()
    }
  }

  // notification bar is visible or hidden based on a value inside the Session Storage
  checkSessionStorage() {
    const valueFromSessionStorage = sessionStorage.getItem('showNotificationBar')

    if (valueFromSessionStorage) {
      this.notificationBar.classList.add('notification-bar-hidden')
    }

    else {
      this.notificationBar.classList.add('notification-bar-visible')
      this.updateLayout()
      this.clickHideButton()

      // update page layout on window resize
      window.addEventListener("resize", debounce(() =>
        this.updateLayout(), 250))
    }
  }

  updateLayout() {
    const valueFromSessionStorage = sessionStorage.getItem('showNotificationBar')

    if (valueFromSessionStorage) {
      this.pageHeader.style.removeProperty('top')
      this.pageBody.style.removeProperty('padding-top')
    }

    else {
      const notificationBarHeight = this.notificationBar.scrollHeight
      const pageHeaderHeight = this.pageHeader.offsetHeight

      this.pageHeader.style.top = notificationBarHeight + 'px'
      this.pageBody.style.paddingTop = (notificationBarHeight + pageHeaderHeight) + 'px'
    }
  }

  // handle click on the hide button
  clickHideButton() {
    const closeButton = document.querySelector('.notification-bar .close-button')

    closeButton.addEventListener('click', () => {
      this.notificationBar.classList.add('notification-bar-hidden', 'notification-bar-transition')
      this.notificationBar.classList.remove('notification-bar-visible')

      this.pageHeader.classList.add('notification-bar-transition')
      this.pageHeader.style.removeProperty('top')

      this.pageBody.classList.add('notification-bar-transition')
      this.pageBody.style.removeProperty('padding-top')

      sessionStorage.setItem('showNotificationBar', 'false')
    })
  }
}